import { CloseIcon } from "components/icons"
import { SearchPopupContent as BaseSearchPopupContent } from "components/domains/search"
import { DirectorySkeletonCard } from "components/domains/directory"
import { VenueSelector } from "components/VenueSelector"
import { useVenue } from "providers/venue"
import { DirectoryOccupantCard } from "../../directory/DirectoryOccupantCard"

export const SearchPopupContent = (props) => {
  const { setVenueFilter, venueFilter, searchResultProps, ...restProps } = props
  const { venues = [] } = useVenue()
  return (
    <BaseSearchPopupContent
      {...restProps}
      closeIcon={CloseIcon}
      searchResultProps={{
        ...searchResultProps,
        renderSearchItem: DirectoryOccupantCard,
        renderLoadingItem: DirectorySkeletonCard,
      }}
      searchBasePopupProps={{
        dialogProps: { disablePortal: true, hideBackdrop: false },
      }}
      venueFilterComponent={
        <VenueSelector
          selectedVenue={venueFilter}
          onClickVenue={setVenueFilter}
          venues={venues}
        />
      }
    />
  )
}
